import ReactDOM from 'react-dom';
import App from './App';
import NoConnectionString from './components/NoConnectionString';
import getQueryParams from './utils/common/getQueryParams';

const { connectionString } = getQueryParams();

ReactDOM.render(!connectionString ? <NoConnectionString /> : <App />, document.getElementById('root'));
